
import AppIntersection from '@/components/core/AppIntersection';
import AppSvgIcon from '@/components/core/AppSvgIcon';
import SizeRecommendationSizeFeedbackCard from './SizeRecommendationSizeFeedbackCard';

export default {
  i18nComponentKey: 'WidgetAddOnSizeRecommendationPopup.components.SizeRecommendationSizeFeedbacks',
  name: 'SizeRecommendationSizeFeedbacks',
  components: {
    AppIntersection,
    AppSvgIcon,
    SizeRecommendationSizeFeedbackCard
  },
  props: {
    sizeFeedbacks: { type: Array, default: () => [] },
    pagy: { type: Object, default: null }
  },
  data() {
    return { expandedReviewId: null };
  }
};
